import React, {Component} from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { fetchLatestFeed, latesClickMediaType } from '../actions';

export default class MediaTypeItem extends Component {

  handelClickMediaType = (mediaType) => {
    const { dispatch } = this.props;
    dispatch(latesClickMediaType(mediaType))
  }

  render () {
    const { mediaType, checkMediaType, index} = this.props;
    let activeIcon = '';
    if (mediaType === checkMediaType) {
      activeIcon = `${mediaType}-icon-active`
    }
    return (
      <div className="mediaType-button">
        <div className={classnames("mediaType-text", {
          "first-blue": index == 0,
          "second-blue": index == 1,
          "third-blue": index == 2,
          "fourth-blue": index == 3,
          "fifth-blue": index == 4,
          "check-mediaType": mediaType === checkMediaType,
        })} onClick={() => this.handelClickMediaType(mediaType)}>
        <i className={classnames("mediaType-icon", `${mediaType}-icon`, `${activeIcon}`)}></i>
        <div style={{display: "inline-block"}}>{t(mediaType)}</div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/MediaTypeItem.js
 **/